import { isValidPhoneNumber, validatePhoneNumberLength } from "libphonenumber-js"
import { postJson, setFieldError, EMAIL_REGEX } from "./request"

// Business offer form. Same endpoint and rules as the "Gauti pasiūlymą" modal
// on the React page: email and phone are required; the phone must be a valid number.
export default function initOfferForm(form) {
  const done = document.getElementById("hv-offer-done")
  const email = form.querySelector('[name="offer[email]"]')
  const phone = form.querySelector('[name="offer[phone]"]')
  const button = form.querySelector('button[type="submit"]')
  const formError = form.querySelector(".hv-calc__formerror")

  // Same check and messages as registration. Numbers without a country code
  // are read as Lithuanian, so both 860000000 and +370 600 00000 pass.
  const phoneError = () => {
    const value = phone.value.trim()
    if (!value) return "Privaloma"
    if (isValidPhoneNumber(value, "LT")) return ""
    switch (validatePhoneNumberLength(value, "LT")) {
      case "TOO_LONG":
        return "Telefono numeris per ilgas"
      case "TOO_SHORT":
        return "Telefono numeris per trumpas"
      default:
        return "Privaloma įvesti galiojantį telefono numerį"
    }
  }
  phone.addEventListener("blur", () => {
    if (phone.value || phone.getAttribute("aria-invalid")) setFieldError(phone, phoneError())
  })

  const validate = () => {
    const value = email.value.trim()
    let emailMessage = ""
    if (!value) emailMessage = "Privaloma"
    else if (value.length > 50) emailMessage = "Max 50 simbolių"
    else if (!EMAIL_REGEX.test(value)) emailMessage = "Neteisingas el. pašto adresas"
    setFieldError(email, emailMessage)
    const phoneMessage = phoneError()
    setFieldError(phone, phoneMessage)
    if (emailMessage) email.focus()
    else if (phoneMessage) phone.focus()
    return !emailMessage && !phoneMessage
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault()
    formError.hidden = true
    if (!validate()) return

    const offer = {}
    new FormData(form).forEach((value, key) => {
      const match = key.match(/^offer\[(.+)\]$/)
      if (match) offer[match[1]] = String(value).trim()
    })

    button.disabled = true
    postJson("/business_pages/business_offer_email", { offer })
      .then(() => {
        form.hidden = true
        done.hidden = false
        done.focus()
      })
      .catch(() => {
        formError.textContent = "Nepavyko išsiųsti užklausos. Bandykite dar kartą arba skambinkite +370 690 00222."
        formError.hidden = false
      })
      .finally(() => {
        button.disabled = false
      })
  })
}
